module.exports = __webpack_public_path__ + "assets/images/Caixa-rayssa_ed076120e6b5118ffb39d84fcad97cf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-two/Caixa-rayssa.png
// module id = 205
// module chunks = 0